module.exports = __webpack_public_path__ + "media/images/landing/siq-16f66df755bf2f9db4946e3a4dcf7813.jpg";